import '../attachment/Navbar.css';
import gitHub from '../assets/Navbar/icons8-github-50-white.png';
import calendly from '../assets/Navbar/icons8-calendar-50-white.png';
import twitter from '../assets/Navbar/icons8-x-50-white.png';
import linkedin from '../assets/Navbar/icons8-linkedin-50-white.png';
import Hamburger from '../attachment/Hamburger';

export default function Navbar() {
    return (
        <nav className='Nav'>
            <Hamburger />
            <a href="/" className="site-title">All you need is software</a>
            <ul className='Social-link'>
                <li className='Social-link-menu'>
                    <a href="https://github.com/Polymatio"> 
                        <img src={gitHub} className="Nav-icon" alt="GitHub logo" />
                    </a>
                    <a href="https://calendly.com/jesus-prras/coffee-chat">
                        <img src={calendly} className="Nav-icon" alt="Calendly logo" />
                    </a>
                    <a href="https://twitter.com/Polymath_Jesus">
                        <img src={twitter} className="Nav-icon" alt="Twitter logo" />
                    </a>
                    <a href="https://www.linkedin.com/in/jp-devs/">
                        <img src={linkedin} className="Nav-icon" alt="LinkedIn logo" />
                    </a>
                </li>
            </ul>
        </nav>
    );
}